window.tasksModule.controller 'TasksIgnoredController', ($scope, $state, $stateParams, $filter, $log, AuthService, TasksService, FEATURE_BITS) ->
  $log = $log.getInstance('TasksIgnoredController', true, false, true)
  $log.log 'tasks ignored controller loaded.'
  $scope.bidiEnabled = FEATURE_BITS.biDirectionalAppointments

  $scope.init = ->
    TasksService.findAll('ignored').then (response) ->
      $scope.tasks = response.data
      $scope.showPlaceholderTask = if $scope.tasks.length is 0 then true else false

  # reload the tasks when one is updated
  $scope.$on 'task-updated', ->
    # tell the task-filter directive to update
    $scope.$broadcast 'update-task-filter-count'
    $scope.init()

  $scope.init()
